import React, { forwardRef } from 'react';
import Collapsible from 'react-collapsible';
import css from './Collapsible.module.css';

const CollapsibleSection = forwardRef((props, ref) => {
  const { title, children, id } = props;

  return (
    <div ref={ref} id={id}>
      <Collapsible
        trigger={
          <div className={css.trigger}>
            {title}
            <span className={css.icon}>+</span>
          </div>
        }
        triggerWhenOpen={
          <div className={css.trigger}>
            {title}
            <span className={css.icon}>-</span>
          </div>
        }
        classParentString={css.collapsible}
        contentInnerClassName={css.content}
      >
        {children}
      </Collapsible>
      <div className={css.divider} />
      <div className={css.spacing} />
    </div>
  );
});

export default CollapsibleSection;
